import React from 'react';
import {useTranslation} from 'react-i18next';
import {useShare} from '../hooks/share.hooks';
import {getTodayNewUserList} from './proxy.service';
import {defaultHeaderImg} from './proxy.variable';
import {
  ArrowRightIcon,
  LastActiveLabel,
  OnlineLabel,
  ProxyCard,
  ProxyEmpty,
  ProxyH5Header,
  goTo,
  toPriceStr,
  useInfinitePager,
} from './proxy-h5.shared';

type UserContentItem = {
  activeDay: string;
  commissionAmount: number;
  userId: number;
  userPhone: string;
};

const ProxyNewUser = (props: any) => {
  const {t} = useTranslation();
  const {doShare} = useShare(true);
  const userCount = props?.route?.params?.userCount || 0;
  const request = React.useCallback(
    (pageNo: number, pageSize: number) =>
      getTodayNewUserList({pageNo, pageSize}),
    [],
  );
  const {items, loading, loadingMore, isEnd, sentinelRef} =
    useInfinitePager<UserContentItem>(request);

  return (
    <div className="proxy-h5-page flex min-h-full flex-col">
      <ProxyH5Header title={t('proxy.new-user.title')} service={false} />
      <div className="flex-1 overflow-y-auto px-3 py-3">
        {items.length > 0 ? (
          <>
            <div className="mb-3 flex items-center text-sm font-bold">
              <span className="text-[var(--proxy-main)]">
                {t('proxy.new-user.today')}
              </span>
              <span className="ml-2 text-[var(--proxy-primary)]">
                {userCount}
              </span>
            </div>
            <div className="space-y-3">
              {items.map(item => (
                <ProxyCard key={item.userId} className="p-3">
                  <div
                    className="cursor-pointer"
                    onClick={() =>
                      goTo('ProxyCommissionDetailUser', {userId: item.userId})
                    }>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <img
                          src={defaultHeaderImg}
                          alt=""
                          className="h-6 w-6 rounded-full"
                        />
                        <span className="ml-2 text-xs font-semibold text-[var(--proxy-main)]">
                          {item.userPhone}
                        </span>
                      </div>
                      {item.activeDay ? (
                        <LastActiveLabel text={item.activeDay} />
                      ) : (
                        <OnlineLabel />
                      )}
                    </div>
                    <div className="mt-2 flex items-center justify-between">
                      <span className="text-xs font-semibold text-[var(--proxy-main)]">
                        {t('proxy.new-user.commission')}
                      </span>
                      <div className="flex items-center gap-1 text-base font-bold text-[#009B22]">
                        <span>{toPriceStr(+item.commissionAmount || 0)}</span>
                        <ArrowRightIcon className="h-3 w-3 text-[#9fa6ac]" />
                      </div>
                    </div>
                  </div>
                </ProxyCard>
              ))}
              {loading && (
                <div className="py-3 text-center text-sm text-[var(--proxy-text)]">
                  Loading...
                </div>
              )}
              <div ref={sentinelRef} />
              {loadingMore && (
                <div className="py-3 text-center text-sm text-[var(--proxy-text)]">
                  Loading...
                </div>
              )}
              {!loading && !loadingMore && isEnd && items.length > 0 && (
                <div className="py-3 text-center text-xs text-[var(--proxy-text)]">
                  {t('label.noMoreData')}
                </div>
              )}
            </div>
          </>
        ) : (
          <ProxyEmpty
            title={t('proxy.new-user.error')}
            actionLabel={t('proxy.new-user.invite')}
            onAction={() => doShare()}
          />
        )}
      </div>
    </div>
  );
};

export default ProxyNewUser;
